import { AssetStatus } from "../../graphql/generated";

export default function activeOrSelected<T extends {
  _id: string;
  status?: AssetStatus | null;
}>(
  items: readonly T[],
  selectedIds: readonly (string | null | undefined)[]
): T[] {
  const selectedIdSet = new Set(selectedIds.filter(Boolean));
  return items.filter(
    (item) =>
      item.status !== AssetStatus.Inactive || selectedIdSet.has(item._id)
  );
}
